<template>
	<div class="col-9 ms-auto me-5 px-3 content-view">
		<div class="col-12 d-flex justify-content-between align-items-center">
			<span class="fw-bold">Resumen de transacciones</span>

			<div class="col-3 mb-2">
				<DateSelector :date="date" @change="dateChanged($event)"></DateSelector>
			</div>
		</div>

		<div class="col-12 row m-0">
			<div class="col-10 mx-auto">
				<div id="chart" ref="chartContainer"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import DateSelector from '../DateSelector.vue';

	export default {
  	components: { DateSelector },
		data(){
			return {
				date: [
          '01-' + moment().format('MM-YYYY'), // initial Date
          moment().format('DD-MM-YYYY'), 			// Final Date
        ],
				chartData : null,
				chart: null,
			}
		},

		methods:{
			getReportData(date){
        axios.get('/home/dashboard-data',{
					params: {
						'date': date
						? [ // formating dates
								this.dateToDBFormat(date[0]),
								this.dateToDBFormat(date[1]),
							]
            : null,
					}
				})
				.then((res) => {
					this.chartData = res.data.chartData;
				})
				.finally(() => {
					this.loadRender();
				})
      },

			/** This runs when the Dateselector value change */
			dateChanged(newValue){
				this.getReportData(newValue);
			},

			/** Loads the chart */
			loadRender(){
				let profitAndValues = Object.values(this.chartData);
        const t = this;

        console.log(this.chartData)
        console.log(Object.keys(this.chartData))

				var options = {
					chart: {
						width	: "100%",
    				height: "auto",
    				type	: "bar",
					},
					stroke: {
						width: 1,
						colors: ["#fff"],
					},
					dataLabels: {
    				enabled: false,
					},
					colors: ["#50ea83", "#2c68d6","#f21212"],
					series: [
						{
							name: 'Ventas',
							data: profitAndValues.map(function(profitAndValue){
                return profitAndValue['sales'].toFixed(2);
              }),
						},
						{
							name: 'Beneficio',
							data: profitAndValues.map(function(profitAndValue){
                return profitAndValue['profit'].toFixed(2);
              })
						},
						{
							name: 'Gastos',
							data: profitAndValues.map(function(profitAndValue){
                return profitAndValue['spends'].toFixed(2);
              })
						},
					],
					xaxis: {
            type: 'category',
						categories: Object.keys(this.chartData),
					},
					yaxis: {
            labels: {
              formatter: function(value) {
                return t.formatNumber(value);
              }
            }
					}
				}

				if(this.chart){ // It's not the first time loading
					this.chart.destroy();
				}

				this.chart = new ApexCharts(this.$refs.chartContainer, options);
				this.chart.render();
			},
		},

		created(){
			this.getReportData(null);
		}
	}
</script>

<style lang="scss">
  .content-view {
    max-height: unset !important;
  }
</style>
